export const getKey = (res: any, key: string): any => {
  const keys = key.split('.')
  for (let i = 0, len = keys.length; i < len; i++) {
    res = res[keys[i]]
    if (!res) return null
  }
  return res
}